<script lang="ts">
  import * as Sidebar from "$lib/components/ui/sidebar/index.js";
  import { LogOut } from "lucide-svelte";
  import { authUser } from "../../services/auth-service";
  import { logoutUser } from "../../services/auth-service";

  let isLoggingOut = false;
  const emailInitial = () => $authUser?.email?.trim()?.charAt(0).toUpperCase() || "?";

  const handleLogout = async () => {
    if (isLoggingOut) return;
    isLoggingOut = true;

    try {
      await logoutUser();
    } finally {
      isLoggingOut = false;
    }
  };
</script>

<Sidebar.Footer class="border-t border-sidebar-border px-2">
  <Sidebar.Menu>
    <Sidebar.MenuItem>
      <Sidebar.MenuButton size="lg" class="gap-3">
        <div class="flex size-8 items-center justify-center rounded-md bg-sidebar-accent text-sidebar-accent-foreground">
          {emailInitial()}
        </div>
        <span class="truncate font-semibold">{$authUser?.email ?? ""}</span>
      </Sidebar.MenuButton>
    </Sidebar.MenuItem>
    <Sidebar.MenuItem>
      <Sidebar.MenuButton onclick={handleLogout}>
        <LogOut />
        <span>{isLoggingOut ? "Logging out..." : "Log out"}</span>
      </Sidebar.MenuButton>
    </Sidebar.MenuItem>
  </Sidebar.Menu>
</Sidebar.Footer>

